import { defaultTo } from 'ramda';
import { SERVICE_NAMES } from '../../../constants/serviceNames';
import { IPublishTerm } from '../../../repositories/billing-tariffs/entities/PublishTerms/PublishTerm';
import { EServiceType, EUnavailableReason, IPublishTermsServices } from '../../../types/reducers/publishTerms';
import { getServiceId } from '../../../utils/publishTerms';

import { mapPeriod } from './mapPeriod';

export function mapServices(terms: Array<IPublishTerm>): IPublishTermsServices {
  return terms.reduce((acc, term) => {
    const {
      identificationRequired,
      unavailableReasonType,
      isAdditional,
      incompatibleServices,
      isDefault,
      isAutoProlongAvailable,
      availableActionsCount,
      isAvailable,
      key,
      baseAuctionBet,
      services,
      promotionType,
      periods,
    } = term;

    const serviceId = getServiceId(services!);

    acc[serviceId] = {
      id: serviceId,
      name: SERVICE_NAMES[serviceId],
      identificationRequired,
      unavailableReasonType: unavailableReasonType as string as EUnavailableReason,
      isAdditional,
      incompatibleServices: incompatibleServices as unknown as Array<EServiceType>,
      isDefault,
      isAutoProlongAvailable,
      availableActionsCount: defaultTo(0, availableActionsCount),
      services: services as unknown as Array<EServiceType>,
      isAvailable,
      key,
      baseAuctionBet: defaultTo(null, baseAuctionBet),
      promotionType,
      period: mapPeriod(periods[0]),
    };

    return acc;
  }, {} as IPublishTermsServices);
}
